import { useToast } from "../store/toast";

const KIND_CLASS: Record<string, string> = {
  info: "border-fg bg-bg",
  success: "border-good bg-bg text-fg",
  error: "border-bad bg-bg text-fg",
};

export function ToastHost() {
  const { toasts, dismiss } = useToast();
  if (toasts.length === 0) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 max-w-[min(420px,calc(100vw-2rem))]"
      aria-live="polite"
      aria-label="Notifications"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`border-2 p-3 shadow-[4px_4px_0_0_var(--fg)] font-mono text-[11px] uppercase tracking-[0.08em] ${KIND_CLASS[t.kind]}`}
          role="status"
        >
          <div className="flex items-start justify-between gap-3">
            <span className="normal-case tracking-normal text-[13px] leading-snug">{t.message}</span>
            <button
              type="button"
              onClick={() => dismiss(t.id)}
              className="shrink-0 text-muted hover:text-fg"
              aria-label="Dismiss"
            >
              ×
            </button>
          </div>
          {t.href && (
            <a
              href={t.href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-2 text-accent hover:underline normal-case"
            >
              View workflow logs ↗
            </a>
          )}
        </div>
      ))}
    </div>
  );
}